import { Flex } from 'reflexbox';
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';

const CenteredSection = props => {
  const theme = useTheme();
  return (
  <Flex
    auto
    column
    //justify="center"
    align={'center'}
    pt={1}
    pl={1}
    pr={1}
    pb={'2px'}
    id={'centerSectionContainer'}
    style={{ background: theme.palette.background.default, height: '100vh', justifyContent: 'center',  overflowY: 'auto' }}
  >
    <Flex
      auto
      column
      align="center"
      id={'centerSectionContent'}
      style={{ maxWidth: '400px', minHeight: '100%', boxSizing: 'border-box', flexDirection: 'column', width: '100%' }}
      pt={1}
      pl={1}
      pr={1}
      pb={2}
      //w={1}
      // mb={2} this margin was causing weird scrolling issue
    >
      {props.children}
    </Flex>
  </Flex>
  );
};

CenteredSection.propTypes = {
  children: PropTypes.node.isRequired
};

export default CenteredSection;
